import { Component, OnInit, Inject, Optional } from '@angular/core';
import { NxiRestService } from '../../services/NXI-Rest.service';
declare let mstarInclusion: any;

@Component({
    selector: 'mstar-component-loader',
    templateUrl: './mstar-component-loader.component.html'
})
export class MStarComponentLoaderComponent implements OnInit {
    region: string = '';
    theme: string = '';
    compRegion: string= '';
    subRegion: string= '';
    constructor(private nxiRestService: NxiRestService, @Optional() @Inject('AppSettings') appSettings: any) {
        this.region = appSettings.ibdConfigMap.mStarRegion !== null ? appSettings.ibdConfigMap.mStarRegion : 'prod';
        this.compRegion = appSettings.ibdConfigMap.mstarCompRegion !== null ? appSettings.ibdConfigMap.mstarCompRegion : 'prod';
        this.subRegion = appSettings.ibdConfigMap.mstarSubRegion !== null ? appSettings.ibdConfigMap.mstarSubRegion : 'prod';
        if (appSettings.themeType === 'ada') {
            this.theme = 'ada';
        } else {
            this.theme = 'conservative';
        }
    }

    ngOnInit() {
        this.callMStarLoader();
    }

    callMStarLoader() {
        this.nxiRestService.getNxiPortfolioRestUrlResponse('getBAAToken').subscribe(
            resp => {
                    mstarInclusion.MStarComponentLoader(resp.access_token, this.nxiRestService.serviceUrl + '/portfolio/updateIFA', this.region,
                    this.nxiRestService.serviceUrl + '/portfolio/getBAAToken', this.compRegion, this.subRegion);              
            }
        );
    }
}
